import { render, staticRenderFns } from "./EmailLog.vue?vue&type=template&id=4008cb17&scoped=true"
import script from "./EmailLog.vue?vue&type=script&lang=js"
export * from "./EmailLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008cb17",
  null
  
)

export default component.exports